/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.userBusinessBanners.internal

import features.userBusinessBanners.models.UserBusinessBannersModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class UserBusinessBannersRequest : NetworkRequest() {

    suspend fun getUserBusinessBanners(
        overrideHeaders: Map<String, String>? = null,
        businessId: String
    ): IOResult<UserBusinessBannersModel> {
        return safeNetworkCall {
            get(
                endpoint = UserBusinessBannersEndpoint.replaceInPath(
                    PathParameter("businessId", businessId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
